import "./utils/sentry/instrument";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import * as Sentry from "@sentry/react";

import AuthWrapper from "./views/Auth/AuthWrapper";
import "./index.css";

console.log("__PACKAGE_NAME__ version: __PACKAGE_VERSION__");

// Render the application with AuthWrapper to handle OAuth authentication
const root = createRoot(
  document.getElementById("root"),
  process.env.NODE_ENV !== "development"
    ? {
        // Callback called when an error is thrown and not caught by an ErrorBoundary.
        onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
          console.warn("Uncaught error", error, errorInfo.componentStack);
        }),
        // Callback called when React catches an error in an ErrorBoundary.
        onCaughtError: Sentry.reactErrorHandler(),
        // Callback called when React automatically recovers from errors.
        onRecoverableError: Sentry.reactErrorHandler(),
      }
    : {},
);

root.render(
  <StrictMode>
    <BrowserRouter>
      <AuthWrapper locale="en-US" />
    </BrowserRouter>
  </StrictMode>,
);
